import { $ } from "./imports";
import { getLanguage } from "./get-language";

const langmenu = () => {

    /*=============== CREATE DROPDOWN ===============*/
    function createLangDropdown(){
        let $blockLang = $('.block-language');

        // Obtenemos texto del idioma actual
        let currentLang = $blockLang.find('.language-link.is-active').attr('hreflang');

        // Si no esta definido, lo definimos según la url
        if(currentLang === undefined){
            currentLang = getLanguage();
            // Seteamos el lang actual
            $blockLang.find(`.language-link[hreflang="${currentLang}"]`).addClass('is-active');
        }

        let btnDropdownTemplate = `<button class="dropdown-toggle button--nostyles lang-menu__btn" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static" data-bs-auto-close="true">${currentLang}</button>`;
    
        if($('.block-language .dropdown-toggle.lang-menu__btn').length <= 0 ){
            // Añadimos boton para activar el menú dropdown
            $blockLang.prepend(btnDropdownTemplate);
        }
        
        // Añadimos clases bootstrap dropdown
        $blockLang.addClass('dropdown lang-menu');
        $blockLang.find('ul').addClass('dropdown-menu dropdown-menu-lg-end lang-menu__list');
        
    }
    // Ejecutamos una vez para convertir las opciones de idioma en dropdown
    createLangDropdown(); 

    /*=============== LISTEN DOM CHANGES ===============*/

    // Función de devolución de llamada que se ejecutará cuando se detecten mutaciones en el DOM
    const mutationCallback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
        // Verificar si se agregó un nuevo nodo al DOM
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Iterar a través de los nodos agregados
            for (const addedNode of mutation.addedNodes) {
                // Verificar si el nodo recién agregado tiene el id "block-alternadordeidioma"
                if (addedNode instanceof Element && addedNode.id === "block-alternadordeidioma") {
                    // El elemento con id "block-alternadordeidioma" se ha agregado al DOM
                    
                    // Puedes realizar las acciones que necesites en este punto
                    // Por ejemplo, manipular el elemento o realizar otras acciones.
                    createLangDropdown();
        
                    // Desconectar el MutationObserver una vez que se ha detectado el cambio (opcional)
                    observer.disconnect();
                }
            }
        }
        }
    };
    
    // Seleccionar el elemento objetivo que se va a observar
    const targetNode = document.querySelector('.header .navbar-collapse');
    
    // Configurar el MutationObserver con la función de devolución de llamada
    const observer = new MutationObserver(mutationCallback);
    
    // Configurar las opciones para observar cambios en el DOM
    const observerOptions = { childList: true, subtree: true };
    
    // Comenzar a observar el DOM
    observer.observe(targetNode, observerOptions);
  

}

export default langmenu;